import React from 'react';
import PlayerRow from './PlayerRow.jsx';

const OverlayTeams = ({ activePlayers, expandedRows, setExpandedRows, setHoveredItem, loadingHeroes }) => {
    const getLane = (player) => {
        const assignedLane = parseInt(player?.assigned_lane ?? '', 10);
        const originalLane = parseInt(player?.original_assigned_lane ?? '', 10);
        if (!isNaN(assignedLane) && assignedLane !== 0) return assignedLane;
        if (!isNaN(originalLane)) return originalLane;
        return 0;
    };

    const getEntityIndex = (player) => {
        return parseInt(player?.entity_index ?? player?.player_slot ?? 0, 10);
    };

    const sortByLaneThenEntity = (a, b) => {
        const laneA = getLane(a);
        const laneB = getLane(b);
        if (laneA !== laneB) return laneA - laneB;
        return getEntityIndex(a) - getEntityIndex(b);
    };

    const amberPlayers = Object.values(activePlayers)
        .filter(p => p?.team === 'amber' || p?.team === 2)
        .sort(sortByLaneThenEntity);

    const sapphirePlayers = Object.values(activePlayers)
        .filter(p => p?.team === 'sapphire' || p?.team === 3)
        .sort(sortByLaneThenEntity);

    const renderRow = (player, index, team) => {
        const playerSlot = player?.player_slot || player?.slot_position || `empty-${index}`;
        return (
            <PlayerRow
                key={`row-${team}-${index}`}
                player={player}
                index={index}
                team={team}
                isExpanded={expandedRows.has(playerSlot)}
                hasSpacer={team === 'sapphire' && index === 3}
                loadingHeroes={loadingHeroes}
                setExpandedRows={setExpandedRows}
                setHoveredItem={setHoveredItem}
            />
        );
    };

    const amberRows = [];
    for (let i = 0; i < 6; i++) {
        amberRows.push(renderRow(amberPlayers[i], i, 'amber'));
    }

    const sapphireRows = [];
    for (let i = 0; i < 6; i++) {
        sapphireRows.push(renderRow(sapphirePlayers[i], i, 'sapphire'));
    }

    return (
        <>
            <div className="overlay-team-column overlay-team-amber">
                {amberRows}
            </div>
            <div className="overlay-team-column overlay-team-sapphire">
                {sapphireRows}
            </div>
        </>
    );
};

export default OverlayTeams;

